import { createSlice } from '@reduxjs/toolkit'

import {
  doUploadFile,
  doQuoteBom,
  doSaveBom,
  doSearchPart,
} from 'pu-utils/BomQuoteApi';

import {
  calculateTotals,
  generateBomReport,
  getReport,
  updatePartPurchaseStatus,
  checkPurchaseStatus,
  assignSubstitutePart,
  assignSimilarPart,
  addPossibleSubstitute,
  removePossibleSubstitute,
} from 'pu-utils/BomActions';

import {
  ERROR, PRICE_SELECTED, QUOTED,
} from 'pu-data/QuoteSteps';

import { doQuotePriceSelected }                                        from 'pu-utils/quoteServicesApi';
import DefaultState, { validateBomParametersRules, aditionalBomRules } from './DefaultState';

const partsService = createSlice({
  name: 'partsService',
  initialState: DefaultState,

  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload;
      state.parameters[name] = value
    },
    changeBomParameter(state, action) {
      const { name, value } = action.payload;
      switch (name) {
        case 'qty1':
          state.bomParameters.quantities[0] = value
          break;
        case 'qty2':
          state.bomParameters.quantities[1] = value
          break;
        case 'qty3':
          state.bomParameters.quantities[2] = value
          break;
        case 'qty4':
          state.bomParameters.quantities[3] = value
          break;
        default:
          if (isNaN(parseInt(name))) {
            state.bomParameters[name] = value
          }else{
            state.bomParameters['bom_parameters'][parseInt(name)] = value
          }
      }
    },
    changeNumBoard(state, action) {
      state.selectedQuantity = action.payload
    },
    changePartAction(state, action){
      const { offer_id, value, quantity } = action.payload;
      updatePartPurchaseStatus(state.quote.offers[offer_id], state.quote.quantities, value, quantity)
      calculateTotals(state.quote.totals, state.quote.offers, state.quote.quantities)
      generateBomReport(state.quote.report, state.quote.offers, state.quote.vendors, state.quote.quantities, state.selectedQuantity)
    },
    changeMountingType(state, action){
      const { offer_id, value } = action.payload;
      state.quote.offers[offer_id].mounting_type_entered = value
      generateBomReport(state.quote.report, state.quote.offers, state.quote.vendors, state.quote.quantities, state.selectedQuantity)
    },
    changeTotals(state, action){
      state.quote.totals = action.payload
    },
    findSubstitutePart(state, action){
      const { offer_id, value, quantity } = action.payload;
      state.focusOfferID = offer_id
      if (state.quote.offers[offer_id].substitutes){
        state.substituteParts = state.quote.offers[offer_id].substitutes
      }
    },
    closeSubstitutePart(state, action){
      state.focusOfferID = null
      state.substituteParts = []
      state.possibleSustitutes = []
      state.possibleOption = []
      state.errors = {}
    },
    searchPartSuccess(state, action){
      state.loading = false
      state.substituteParts = action.payload
    },
    searchPartFailure(state, action){
      state.loading = false
    },
    saveSubstitutePartFailure(state, action){
      const {message} = action.payload; 
      state.errors = {"substitute_part" : message}
    },
    selectSubstitutePart(state, action){
      const { is_check, offer_id, substitute_id, substitute, selected_quantity, type, option_id, qty } = action.payload;
      if (type == "substitute")
      { 
        if (state.possibleSustitutes.length == 0){
          let vendor_options = substitute.vendor_options;
          let new_vendor_options = [];
          vendor_options.forEach(function (option, index) {
            var new_option = {...option};
            if(option_id == option.id){
              new_option.qty_selected = qty;
              new_option.check = is_check;
            }
            new_vendor_options.push(new_option);
          });

          let substitute_new = {...substitute, vendor_options:new_vendor_options }
          state.possibleSustitutes = [substitute_new]
        }else{
          var s = [];
          state.possibleSustitutes.forEach(function (substitute, index){
            if (substitute.id == substitute_id){
              let vendor_options = substitute.vendor_options;
              let new_vendor_options = [];
              vendor_options.forEach(function (option, index) {
                var new_option = {...option};
                if(option_id == option.id){
                  new_option.qty_selected = qty;
                  new_option.check = is_check;
                }
                new_vendor_options.push(new_option);
              });
              let substitute_new = {...substitute, vendor_options:new_vendor_options }
              s.push(substitute_new)
            }else{
              s.push(substitute)
            }
          })
          state.possibleSustitutes = s
        }
      }else{
        if(is_check){
          state.possibleOption.push(substitute)
        }else{
          var new_possibleOption = state.possibleOption.filter(
            function(value, index, arr){ 
              if (value.id != substitute.id)
              return value;
          });
          state.possibleOption=new_possibleOption;
        }
      }
      
    },
    saveSubstitutePart(state, action){
      const type = action.payload;
      const offer_id = state.focusOfferID;
      if (type == "substitute")
      {
        assignSubstitutePart(state.quote.offers[offer_id], state.quote.quantities, state.possibleSustitutes[0], state.selectedQuantity)
      }else{
        assignSimilarPart(state.quote.offers[offer_id], state.quote.quantities, state.possibleOption[0], state.selectedQuantity)
      }
      calculateTotals(state.quote.totals, state.quote.offers, state.quote.quantities)
      generateBomReport(state.quote.report, state.quote.offers, state.quote.vendors, state.quote.quantities, state.selectedQuantity)
      state.focusOfferID = null
      state.substituteParts = []
      state.possibleSustitutes = []
      state.possibleOption = []
      state.errors = {}
      // PASS THE NEW OFFER
    },
    formValidated(state, action) {
      state.errors = action.payload
    },
    bomActionStart(state) {
      state.loading = true
    },
    setPriceSelected(state, action) {
      const { row_selected, column_selected, selected_quantity } = action.payload
      state.selectedQuantity = selected_quantity
      state.price = state.quote.totals[selected_quantity]
      state.showSummary = true
      state.itemSelected = true
      state.quoteStep = PRICE_SELECTED
      state.parameters.row_selected = row_selected
      state.parameters.column_selected = column_selected
    },
    bomUploadSuccess(state, action){
      state.errors['bom_file'] = ''
      state.bomId = action.payload.bom
      state.workbook = action.payload.workbook
      state.bomStep = 1
      state.loading = false
      state.showModal = true
    },
    bomUploadFailure(state, action){
      state.errors['bom_file'] = action.payload
      state.bomId = null
      state.loading = false
      state.workbook = []
    },
    bomQuoteSuccess(state, action){
      state.loading = false
      state.bomStep = 2
      state.bomQuoteNumber = action.payload.bom_quote
      state.quote =  action.payload.result
      state.quote.totals = {}
      state.quote.report = {}
      state.quoteStep = QUOTED
      calculateTotals(state.quote.totals, state.quote.offers, state.quote.quantities)
      generateBomReport(state.quote.report, state.quote.offers, state.quote.vendors, state.quote.quantities, state.selectedQuantity)
    },
    bomQuoteFailure(state, action){
      state.loading = false
    },
    bomSaveSuccess(state, action){
      state.quote = action.payload.quote
      state.quote.report = action.payload.report
      state.showSummary = true
      state.showModal = false
      state.loading = false
    },
    bomReportUpdate(state, action){
      state.quote.report = action.payload.report
    },
    bomSaveFailure(state, action){
      state.loading = false
    },
    closeBomSection(state){
      Object.assign(state, DefaultState)
    },
    supplyParts(state, action) {
      state.provideParts = action.payload
      if (state.provideParts){
        // Object.assign(state, DefaultState)
        state.itemSelected = false
      }
    },
    allowEdit(state, action) {
      state.showSummary = false
      state.bomStep = 2
      state.showModal = true
    },
    showPartByFilter(state,action) {
      state.filter = action.payload
    },
    deleteQuote(state) {
      Object.assign(state, DefaultState)
    },
  },
});

export const {
  changeParameter,
  formValidated,
  setPriceSelected,
  supplyParts,
  allowEdit,
  deleteQuote,
  bomUploadSuccess,
  bomUploadFailure,
  bomQuoteSuccess,
  bomQuoteFailure,
  bomSaveSuccess,
  bomSaveFailure,
  changeNumBoard,
  changeMountingType,
  changePartAction,
  changeTotals,
  findSubstitutePart,
  closeBomSection,
  changeBomParameter,
  bomActionStart,
  selectSubstitutePart,
  closeSubstitutePart,
  searchPartSuccess,
  searchPartFailure,
  showPartByFilter,
  bomReportUpdate,
  saveSubstitutePartFailure,
  saveSubstitutePart,

} = partsService.actions

export default partsService.reducer

const validateBomParameters = (parameters) => {
  const errors = {}
  Object.keys(parameters).forEach((key) => {
    if (!validateBomParametersRules[key]) return;
    const newError = validateBomParametersRules[key](parameters[key]);
    if (newError)
      errors[key] = newError
  });

  Object.entries(aditionalBomRules).forEach(([key, rule]) => {
    const newError = rule(parameters);
    if (newError)
      errors[key] = newError
  });

  return errors
}

export const updatePartStatus = (quote, offer_id, value, quantity) => async dispatch => {
  const offer = quote.offers[offer_id];
  if ((offer.status[quantity] != "enough-stock" 
       && offer.status[quantity] != "substitute" 
       && offer.status[quantity] != "other")
      && value == "buy"){
    const errors = {"change_part_action" : "The " + offer.mpn + " part cannot be bought, please take other action about this part."}
    dispatch(formValidated(errors))
  }else{
    dispatch(formValidated({}))
    dispatch(changePartAction({offer_id, value, quantity}))
  }
}

export const uploadBomFile = (file, authToken) => async dispatch => {
  try {
    dispatch(bomActionStart())
    const response = await doUploadFile(file, authToken)
    if (response.code == 400 ){
      dispatch(bomUploadFailure(response.message))
    }else{
      dispatch(bomUploadSuccess(response))
    }
  } catch (err) {
    console.log(err);
    dispatch(bomUploadFailure(err.toString()))
  }
}

export const quoteBom = (itemId, bomId, bomParameters, authToken)  => async dispatch => {
  try {
    const errors = validateBomParameters(bomParameters)
    if (errors && Object.keys(errors).length) {
      dispatch(formValidated(errors))
      return;
    }
    dispatch(formValidated({}))
    dispatch(bomActionStart())

    var response = await doQuoteBom(itemId, bomId, bomParameters, authToken)

    if (response.result && response.result.offers){
      // var totals = await calculateTotals(response.result.offers, response.result.quantities)
      // response.result['totals'] = totals
      dispatch(bomQuoteSuccess(response))
      // let quantity = response.result.quantities[0]
      // const {report, errors } = getReport(response.result, quantity)
      // dispatch(bomReportUpdate(report))
    }else{
      dispatch(bomQuoteFailure())
    }
  } catch (err) {
    console.log(err);
    dispatch(bomQuoteFailure(err.toString()))
  }
}

export const priceSelected = (data, authToken, number) => async (dispatch) => {
  try {
    dispatch(setPriceSelected(data))
    await doQuotePriceSelected(data, authToken, number)
  } catch (err) {
    // error
  }
}

export const saveBom = (bomQuoteNumber, selected_quantity, quote, report, authToken) => async (dispatch) => {
  try {
    // validate everything is ok
    const errors = checkPurchaseStatus(quote.offers, selected_quantity)
    if (errors && Object.keys(errors).length) {
      dispatch(formValidated(errors))
      return;
    }

    dispatch(formValidated({}))
    dispatch(bomActionStart())

    const response = await doSaveBom(bomQuoteNumber, quote, report, authToken)
    if (response.code == 200 ) {
      dispatch(bomSaveSuccess({ quote, report }))
      dispatch(priceSelected({ selected_quantity, row_selected: 0, column_selected: 0 }, authToken, bomQuoteNumber))
    } else {
      dispatch(bomSaveFailure())
    }
  } catch (err) {
    console.log(err);
    dispatch(bomSaveFailure(err.toString()))
  }
}

export const searchPart = (mpn) => async dispatch => {
  try {
    if(mpn == ""){
      const errors = {"search_part" : "Please, enter a validate part."}
      dispatch(formValidated(errors))
      return;
    }

    dispatch(formValidated({}))
    dispatch(bomActionStart())

    const response = await doSearchPart(mpn)

    if (response.code == 200 ){
      dispatch(searchPartSuccess(response.result))
    }else{
      dispatch(searchPartFailure())
    }
  } catch (err) {
    console.log(err);
    dispatch(bomSaveFailure(err.toString()))
  }
}


